import styled from '@emotion/styled'

export const FieldWrapper = styled.div`
    display: flex;
    margin-bottom: 1.5rem;
    width: 100%;
`
